<script>
import { generateGUID } from "../utils";

export default {
  name: "FChildFields",
  props: {
    fields: { type: Array, default: () => [] },
  },
  methods: {
    getKey(entry) {
      if (!entry.__uuid) {
        entry.__uuid = generateGUID();
      }

      return entry.__uuid;
    },
    on_select(field) {
      this.$emit("select", field);
    },
    on_changed_fields() {
      console.log(`[${new Date().toISOString()}] FChildFields @change event:`, {
        component: "FChildFields",
        fieldsCount: this.fields.length,
        fields: this.fields,
      });
      this.$emit("change", this.fields);
    },
  },
};
</script>

<template>
  <ul class="list-group">
    <li
      v-for="(field, index) in fields"
      :key="getKey(field)"
      class="list-group-item"
    >
      <div class="d-flex w-100 justify-content-between">
        <a @click="on_select(field)" class="btn btn-link">
          {{ field.name }}
        </a>

        <o-list-actions
          :index="index"
          :list="fields"
          @change="on_changed_fields"
        ></o-list-actions>
      </div>
    </li>
  </ul>
</template>

<style scoped></style>
